export default __webpack_public_path__ + "static/content-45b94af923d8a3f912fb396db209ba40.jpg";